import React from 'react';
import { useSelector } from 'react-redux';
import ApplicationsVendorRoutes from '../components/applicationRoutes/VendorRoutes';
export default function VendorRoutes(props) {
  const {config} = useSelector((state) => state.config);
  return config.maintenance ? (
    <div className='maintenance'>
      <h1>Sorry for the inconvenience. We’ll be back soon!</h1>
    </div>
  ) : (
    <ApplicationsVendorRoutes {...props} />
  );
}